/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { ProvisionalDetailPageService } from '@pages/ProvisionalDetailPage/services';

const getSrv = () => {
  return vappContainer.get<ProvisionalDetailPageService>(
    ProvisionalDetailPageService.name
  );
};

export const updateKyc = async (context: any, event: any) => {
  const currentState = 'UPDATE_KYC';
  const method = 'updateKyc';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      const srv = getSrv();
      const updateKycStatus = await srv.agent.getFeatureSectionSync();
      if (updateKycStatus) {
        return resolve({
          key: 'UPDATE_KYC_SUCCESS',
          value: updateKycStatus
        });
      } else {
        const msg = 'Page content not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'UPDATE_KYC_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'UPDATE_KYC_FAILED',
        value: err?.message,
      });
    }
  });
};
